import React, { useEffect } from "react";
import CamundaBanner from "../../components/Capabilities/CamundaBanner";
import CamundaSolution from "../../components/Capabilities/CamundaSolution";
import CamundaAcceleters from "../../components/Capabilities/CamundaAcceleters";
import CamundaStats from "../../components/Capabilities/CamundaStats";
import CamundaCaseStudy from "../../components/Capabilities/CamundaCaseStudy";
import CamundaFaqs from "../../components/Capabilities/CamundaFaqs";
import CamundaCTA from "../../components/Capabilities/CamundaCTA";
import CamundaSteps from "../../components/Capabilities/CamundaSteps";
const CamundaPage = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <>
    <title>Camunda at Truviq System</title>
      <CamundaBanner />
      <CamundaSolution />
      <CamundaSteps />
      <CamundaAcceleters />
      <CamundaStats />
      <CamundaCaseStudy />
      <CamundaFaqs />
      <CamundaCTA/>
    </>
  );
};

export default CamundaPage;
